// eslint-disable-next-line import/extensions
import store from '~/store'

export default (to, from, next) => {
	const userIsNotAdmin =
		store.getters['Auth/user'].list_of_roles.indexOf(1) === -1 &&
		store.getters['Auth/user'].list_of_roles.indexOf(3) === -1 &&
		store.getters['Auth/user'].list_of_roles.indexOf(4) === -1
	if (store.getters['Auth/check'] && userIsNotAdmin) {
		next({ name: 'dashboard' })
	} else {
		next()
	}
}
